const colorPallets = {
  red1: "#DC0032",
  white1: "#ffffff",
  black: "#000000",
  secondaryGrey1: "#5A5A5A",
  secondaryGrey2: "#828282",
  secondaryGrey3: "#B4B4B4",
  grey4: "#D2D2D2",
  grey5: "#EBEBEB",
  error: " #E31C79",
  iconColor: "#1C1B1F",
  lightestGrey: "#e9ebf1",
  successGreen: "#00873E",
  grey900: "#101828",
  lightCraftingBlue: "#E3EFF7",
  craftingBlue: "#B9D7EB",
  avatarBG: "#8246AF",
  lightGrey: "#EBEBEB",
  red2: "#dc00321f",
  grey6: "#6B7983",
  grey7: "#C3CACE",
  whiteSmoke: "#F5F5F5",
  azuerishWhite: "#e2eef6",
  turquoise: "#23262f",
  darkGrey: "#00000029",
  purple: "#8246AF",
  cyan: "#0092BD",
  green: "#34B78F",
  pink: "#FF33CE",
  notificationsRed: "#FCE5EA",
  charade: "#464E5F",
  lightPurple: "#A77BCA",
  lightPurple2: "#d8c7e8",
  lightBlue: "#5BC2E7",
  lightBlue3: "#b4e5f5",
  aquaGreen: "#8FD6BD",
  lightGreen: "#bae6d6",
  darkViolet: "#582C83",
  cerulean: "#006BA6", //medium Blue
  cyan2: "#06D6E9",
  magenta: "#EB008A",
  lightBlue2: "#06D6E91A",
  cobaltBlue: "#002884",
  coral: "#ff7961",
  indigo: "#3f50b5",
  opaqueBackground: "#1C1B1F50",
  amberYellow:"#FFBF00"
};

const variables = {
  bodyBg: colorPallets.white1,
  primaryBg: colorPallets.red1,
  textDefault: colorPallets.black,
  grey1: colorPallets.secondaryGrey1,
  grey2: colorPallets.secondaryGrey2,
  textPrimary: colorPallets.white1,
  grey3: colorPallets.secondaryGrey3,
  grey4: colorPallets.grey4,
  grey5: colorPallets.grey5,
  grey900: colorPallets.grey900,
  iconColor: colorPallets.iconColor,
  successGreen: colorPallets.successGreen,
  lightCraftingBlue: colorPallets.lightCraftingBlue,
  avatarBG: colorPallets.avatarBG,
  lightGrey: colorPallets.lightGrey,
  red2: colorPallets.red2,
  grey6: colorPallets.grey6,
  grey7: colorPallets.grey7,
  whiteSmoke: colorPallets.whiteSmoke,
  azuerishWhite: colorPallets.azuerishWhite,
  turquoise: colorPallets.turquoise,
  darkGrey: colorPallets.darkGrey,
  purple: colorPallets.purple,
  pink: colorPallets.pink,
  cyan: colorPallets.cyan,
  green: colorPallets.green,
  notificationsRed: colorPallets.notificationsRed,
  charade: colorPallets.charade,
  lightPurple: colorPallets.lightPurple,
  lightBlue: colorPallets.lightBlue,
  aquaGreen: colorPallets.aquaGreen,
  darkViolet: colorPallets.darkViolet,
  cerulean: colorPallets.cerulean,
  cyan2: colorPallets.cyan2,
  magenta: colorPallets.magenta,
  lightBlue2: colorPallets.lightBlue2,
  cobaltBlue: colorPallets.cobaltBlue,
  coral: colorPallets.coral,
  indigo: colorPallets.indigo,
  lightPurple2: colorPallets.lightPurple2,
  lightBlue3: colorPallets.lightBlue3,
  lightGreen: colorPallets.lightGreen,
  opaqueBackground: colorPallets.opaqueBackground,
  amberYellow:colorPallets.amberYellow,

  radiusXss: "0.165rem", //2px
  radiusSm: "0.25rem", //4px
  radiusMd: "0.375rem", //6px
  radiusLg: "0.5rem", //8px
  radiusXXLarge: "1.875rem", // 30px
  radiusLg2: "1.25rem", //20px

  fontSizeSmallest: "0.75rem", //12px
  fontSizeSmallest2: "0.563rem", //9px
  fontSizeSmall: "0.875rem", //14px
  lineHeightSmall: "1.125rem", //18px

  fontSizeNormal: "1rem", //16px
  lineHeightNormal: "1.25rem", //20px

  fontSizeLarge: "1.125rem", //18px
  lineHeightLarge: "1.375rem", //22px

  fontSizeXlarge: "1.25rem", //20px
  lineHeightXlarge: "1.5rem", //24px

  fontSizeXxxlarge: "2rem", //32px

  fontSizeXxlarge: "1.5rem", //24px
  lineHeightXxlarge: "1.75rem", //28px

  fontSizeXxxLarge: "2rem", //24px

  fontSizeheading1: "3.75rem", //60px
  lineHeightHeading1: "4.125rem", //66px
  fontSizeheading2: "2.75rem", //44px
  fontSizeheading3: "2rem", //34px
  lineHeightHeading2: "3rem", //40px

  mediumHeight: "3rem", //48px

  fontWeightNormal: 400,
  fontWeightBold: 700,

  buttonHeightNormal: "2.5rem",
  iconHeight: "1.25rem",
  iconWidth: "1.25rem",
  iconWidth2: "1.125rem",
  iconHeight2: "1.125rem",
  inputHeightSmall: "2.5rem",
  markActiveInputWidth: "19.063rem",

  iconHeightLarge: "1.5rem",
  iconWidthLarge: "1.5rem",

  addProductHeight: "3rem",
  countrySelectWidth: "25%",
  removeSectionWidth: "3rem",
  removeSectionWidthMobile: "3rem",
  inputContainerMinHeight: "3.5rem",
  graphsMinHeight: "32.675rem", 

  avatarLg: "3.75rem",
  avatarMini: "2.5rem",

  boxShadow: `1px 1px 10px #dc00321f
  ${colorPallets.lightestGrey}`,
  boxShadowBottom: `0 3px 3px -1px ${colorPallets.lightestGrey}`,

  fontFamilyRegular: "denso-regular",
  fontFamilyBold: "denso-bold",

  quickLinksPopupWidth: "23.375rem",
  error: colorPallets.error,

  marginQuarter: "0.25rem",
  marginXSmallest: "0.375rem", //6px
  marginSmallest: "0.625rem",
  marginSmall: "0.75rem",
  marginMedium: "1.5rem",
  marginMedium2: "1.25rem",
  marginMediumSmall: "1rem",
  marginMediumLarge: "2.125rem",
  marginMediumLarge2: "2.5rem",
  marginLarge: "2.75rem",
  marginLarge3: "2rem",

  marginXLarge: "3.5rem",
  marginQuad: "4rem",
  marginLg: "6.5rem",
  marginXLg: "6.875rem",
  marginAuto: "auto",
  marginMediumLarge1: "1.5625rem",
  marginLg2: "1.625rem", //26px
  marginLg3: "1.875rem", //30px
  marginHalf: "0.5rem",

  closeIcon: "1.25rem",

  halfWidth: "50vw",
  fullWidth: "100%",

  fullScreenWidth: "100vw",
  fullScreenHeight: "100vh",

  halfHeight: "50vh",
  fullHeight: "100%",
  menuIconWidth: "1.75rem",
  menuIconHeight: "1.75rem",

  authFormWidth: "32.875rem",

  paddingSmallest: "0.625rem", //10px
  paddingSmallest2: "0.313rem", //5px
  paddingSmallest3: "0.188rem", //3px
  paddingSmaller: "0.875rem",
  paddingMedium: "1.5rem",
  paddingMedium2: "1.625rem", //26px
  paddingSmedium: "1.25rem",
  paddingSmall: "1rem",
  paddingMediumLarge: "2.125rem",
  paddingLG: "2.25rem",
  paddingSmallLG: "2rem",
  paddingSmall2: "0.75rem",
  paddingSmall3: "0.813rem",
  paddingXXXSmall: "0.125rem",
  paddingXSmall: "0.375rem", //6px
  paddingXXXXLarge: "3.75rem", //60px
  paddingXXSmall: "0.313rem",
  paddingHalf: "0.5rem",
  paddingNone: "0rem",
  paddingQuarter: "0.25rem",
  paddingTop: "2rem",

  smallInputPadding: "0.813rem",
  customInputHeight: "3.875rem",

  gapMedium: "2.25rem",
  gapMedium2: "2.125rem", //34px
  gapSmall: "1.5rem",
  gapMediumSmall: "1.25rem",
  gapSmaller: "1rem",
  gapXS: "0.5rem",
  gapXS2: "0.688rem",
  gapXS3: "0.75rem",
  gapXS4: "0.313rem", //5px
  mediumGap: "1.375rem",
  gapLarge1: "1.75rem",
  gapLarge2: "2rem",
  mediumGap2: "1.875rem",
  gapXS1: "0.625rem",
  gapMediumSmaller: "1.075rem",

  navBorderBottom: "1px solid #B4B4B4",
  dFlex: "flex",
  dFlex2: "flex-start",
  spaceBetween: "space-between",
  alignCenter: "center",
  justifyCenter: "center",
  justifyContentRight: "right",
  justifyContentFlexEnd: "flex-end",
  positionAbsolute: "absolute",
  positionRelative: "relative",

  dBlock: "block",
  highBlur: "blur(0.5rem)",

  navbarLogoWidth: "7.313", //117px
  navbarLogoHeight: "2.438rem", //39px
  navbarSidesPadding: "2.125rem", //34px

  navHeight: "4.6rem",
  countTagBorderRadius: "0.625rem",

  popoverBorder: "1px solid #D2D2D2",

  unset: "unset",
  notifyIcon: "1.5rem",
  dot: "0.5rem",
  activeInactiveHeight: "24.875rem",

  otpInputBoxShadow: "0rem 0.25rem 0.5rem rgba(0, 0, 0, 0.02)",
  otpInputBorder: "1px solid #D2D2D2",
  otpInputWidth: "7rem",
  otpInputWidthMobile: "5.5rem",
  otpInputHeight: "3.75rem",
  otpScreenLinkGap: "2.125rem 0",
  arrowRightMargin: "1rem",
  logoHeight: "3.3125rem",
  logoWidth: "10rem",

  actionListWidth: "17.3rem",
  actionListPadding: "0 1rem",
  actionListItemPadding: "1rem 0",

  tagHeight: "2rem",
  actionIconSize: "1.5rem",
  tableActionsListIconSize: "1rem",

  tagBorder: `1px solid ${colorPallets.craftingBlue}`,
  tagBorderRadius: "1.25rem",
  myAccountPopUpWidth: "15.75rem",
  blurBackground: "rgba(0, 0, 0, 0.7)",
  navDownArroWIcon: "1rem",
  accountsPopUpTop: "4.063rem",

  mainPageContainerMargin: "1.5rem 0",
  productCategorySearchInputWidth: "25rem",

  inputPadding: "0.625rem 1rem",
  // largeInputPadding: "1.25rem 1rem",
  addButtonIconSize: "20px",
  myAccountContainerWidth: "48.125rem",
  overflowInitial: "initial",
  overflowScroll: "scroll",
  overflowHidden: "hidden",

  borderRadius: "0.9375rem",
  borderRadius2: "0.125rem", //2px
  flex1: "1",

  border: `1px solid ${colorPallets.grey4}`,
  moreOutlinedIconPaddingTop: "0.313rem",
  flexDirection: "column",
  flexDirection2: "row",
  operationAuditLegendMenubarWidth: "18.75rem", //300px
  operationAuditLegendMenubarHeight: "5.625rem", //90px
  operationAuditLegendMenubarMarginTop: "1.188rem", //19px
  operationAuditLegendMenubarTabletHeight: "1.406rem", //22.5px
  operationAuditLegendMenubarMobileMarginTop: "0.313rem", //5px
  operationAuditLegendMenubarMobileGap: "0.188rem", //3px
  dashboardContainerMarginTop: "5.625rem", //90px
  position: "absolute",
  zIndex: "9",
  dashboardContainerBottomTopSectionPadding: "0 1.25rem",
  dashboardContainerMobileMarginTop: "8.625rem",
  dashboardContainerMobileMarginTopMb: "12.1rem",
  overflowUnset: "unset",
  smallIconWidth: "1rem",
  smallIconHeight: "1rem",
  crossIconWidth: "1rem",
  crossIconHeight: "1rem",
  flexWrap: "wrap",
  lineHeightMedium: "1rem",

  imagePreviewWidth: "2.75rem",
  imagePreviewHeight: "2.75rem",

  questionnaireBottomContainerHeight: "calc(100% - 3.25rem)",
  questionnaireNavigationContainerWidth: "23.75rem",
  questionnaireNavigationContainerHeight: "calc(100vh - 16rem)",
  questionnaireNavigationContainerHeightSmall: "calc(100vh - 11.3rem)",

  // questionnaireNavigationTreeHeight: "calc(100% - 6.5rem)",
  // questionnaireSectionsContainerHeight: "calc(100% - 14rem)",
  // questionnaireSectionsContainerHeightSmall: "calc(100% - 15.25rem)",
  questionRightWidth: "17.5rem",
  treeDivWidth: "calc(100% + 1.5rem)",
  treeDivWidthSmall: "calc(100% - 1.5rem)",
  questionnaireSectionMaxHeight: "calc(100vh - 20.5rem)",

  customTableHeight: "calc(100vh - 15.5rem)",
  customTableMobileHeight: "calc(100vh - 21.5rem)",
  dasboardContainerHeight: "calc(100vh - 12rem)",
  dasboardContainerHeightMb: "calc(100vh - 15rem)",

  notificationBoxShadow:
    "0px 4px 6px -2px rgba(16, 24, 40, 0.03), 0px 12px 16px -4px rgba(16, 24, 40, 0.06)",
  notificationsBoxWidth: "28.125rem",
  borderRadiusCircle: "50%",
  overflowAuto: "auto",
  notificationsDetailPageWidth: "52.75rem",
  marginBottomLevel4Graph: "1.25rem",
  dashboardGraphLayoutSectionsWidth: "calc(50% - 0.625rem)",
  tentativeDateTableGrid: "9.375rem repeat(2, minmax(10rem,35.5rem))",
  errorIconWidth: "8rem",
  evaluationStatusDropdownWidth: "15rem",
  mediaContainerWidth: "120px",
  audioPlayContainerWidth: "220px",
  audioRecorderWidth: "24.75rem",
  audioElementHeight: "3.12rem",
  markerSize: "3rem",
  bottom: "1rem",
  left: "1.5rem",
  borderNone: "none",
  border2: `1px solid ${colorPallets.grey4}`,
  widthOfDefaultScreen: "37.5rem",
  widthOfSmallScreen: "69rem",
  widthOfMobileScreen: "90%",
  objectFitCover: "cover",
  zIndex2: 2,
  callLobbyComponentHeight: "24rem",
  marginCallLobbyComponent: "3rem 0",
  box: "0.813rem",
  ellipsisWidth: "9.375rem",
  ellipsisWidth2: "22.375rem",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  paddingTop2: "10.45rem",
  minHeight2: "13.375rem",
  marginLeftLegend: "0.625rem",
  customizedTooltipPadding: "1rem 1rem 0 1rem",
  customizedTooltipBorder: "0.5px solid grey",
  spinnerAndChooseFilterTextHeight: "calc(100% - 2rem)",
  fill: "transparent",
  previewMinHeight: "4.5rem",
  remoteAuditSectionWidth: "calc(50% - 1rem)",
  remoteAuditBottomContainerHeight: "calc(100vh - 7.5rem)",
  remoteMainSectionWrapperHeight: "calc(100% - 3.5rem)",
  remoteQuestionSectionHeight: `calc(100% - 6.5rem)`,
  tooltipWidth: "21.875rem",
  requestAccessButtonWidth: "8rem",
  remoteVideoContainerHeight: "calc(100% - 4rem)",
  remoteVideoContainerWrapperHeight: "calc(100% - 3.5rem)",
  smallWidth: "1rem",
  breadCrumbTextWidth: "calc(100% - 1rem)",
};

export default variables;
